import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { company, navLinks } from '../../data/company';
export function Footer() {
  const footerLinks = navLinks.filter(link => link.to !== '/');
  return <footer className="border-t border-edge bg-coal" data-id="element-99" data-mp="ao03pr5hr26e">
      <div className="mx-auto max-w-[1320px] px-5 pb-10 pt-16 text-center md:px-8 md:pt-20 lg:text-left" data-id="element-100" data-mp="5mav0i5qr0lh">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-101" data-mp="pkfbvxum70l">
          <div className="lg:col-span-5" data-id="element-102" data-mp="3s2x4hdaq6z3j">
            <Link to="/" aria-label="Universal Packaging Industries, home" className="inline-block" data-id="element-103" data-mp="3s13zs3joaoy6">
              <img src={company.logoWhite} alt="Universal Packaging Industries LLC" className="h-11 w-auto" data-id="element-104" data-mp="3n43qljrj162u" />
            </Link>
            <p className="mx-auto mt-6 max-w-md leading-relaxed text-muted lg:mx-0" data-id="element-105" data-mp="3j05u7gtl69dh">{company.footerBlurb}</p>
          </div>

          <nav aria-label="Footer" className="lg:col-span-2 lg:col-start-7" data-id="element-106" data-mp="3939heywnn134">
            <h2 className="font-display text-xl font-bold uppercase tracking-wide text-flame" data-id="element-107" data-mp="3965igw3su5vs">Pages</h2>
            <ul className="mt-5 flex flex-wrap justify-center gap-x-6 gap-y-3 lg:block lg:space-y-3" data-id="element-108" data-mp="2p3tfmctf8ld1">
              {footerLinks.map(link => <li key={link.to} data-id="element-109" data-mp="2bdpwvvtr39sc">
                  <Link to={link.to} className="text-chalk/80 transition-colors duration-150 hover:text-flame" data-id="element-110" data-mp="2balm2fls5fsp">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="lg:col-span-4" data-id="element-111" data-mp="383796tn8nu30">
            <h2 className="font-display text-xl font-bold uppercase tracking-wide text-flame" data-id="element-112" data-mp="381w8x3t054gn">Contact</h2>
            <ul className="mt-5 space-y-4 text-chalk/80" data-id="element-113" data-mp="2u50m88jtvei4">
              <li className="flex flex-col items-center gap-2 lg:flex-row lg:items-start lg:gap-3" data-id="element-114" data-mp="2z0y2yfz06mvf">
                <MapPinIcon className="h-5 w-5 shrink-0 text-flame lg:mt-0.5" aria-hidden="true" data-id="element-115" data-mp="1imprbgfrtxyk" />
                <span className="max-w-xs lg:max-w-none" data-id="element-116" data-mp="1nnvllip2xta7">{company.address}</span>
              </li>
              <li className="flex flex-col items-center gap-2 lg:flex-row lg:items-start lg:gap-3" data-id="element-117" data-mp="13job8nn1hx6b">
                <PhoneIcon className="h-5 w-5 shrink-0 text-flame lg:mt-0.5" aria-hidden="true" data-id="element-118" data-mp="zk76xxjcn62q" />
                <a href={company.phoneHref} className="transition-colors duration-150 hover:text-flame" data-id="element-119" data-mp="ure116c59rp2">
                  {company.phone}
                </a>
              </li>
              <li className="flex flex-col items-center gap-2 lg:flex-row lg:items-start lg:gap-3" data-id="element-120" data-mp="kurgkinqd2nk">
                <MailIcon className="h-5 w-5 shrink-0 text-flame lg:mt-0.5" aria-hidden="true" data-id="element-121" data-mp="func5r03jydp" />
                <a href={company.emailHref} className="break-all transition-colors duration-150 hover:text-flame" data-id="element-122" data-mp="bt1pxf1oa7qu">
                  {company.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 border-t border-edge pt-8 text-sm text-muted md:mt-16" data-id="element-123" data-mp="2669rdpk5lhlg">
          Copyright © 2026 {company.legalName}. All rights reserved.
        </div>
      </div>
    </footer>;
}